import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.css'],
})
export class TeamComponent extends BaseListCtl {
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super('', locator, route);
    let _self = this;
    //this.form.preload["applist"] = [];
    locator.getPathVariable(route, function (params: any) {
      //_self.form.searchParams["appId"] = params["appId"];
    });

    _self.locator.config
      .getProperty('endpoint.user')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });
  }

  /*
  * Initialize component
  */
  override ngOnInit() {
    this.preload();
    this.team();
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.firstName = data.firstName;
    form.lastName = data.lastName;
    form.loginId = data.loginId;
    form.password = data.password;
    form.roleId = data.roleId;
    form.roleName = data.roleName;
  }

  public new() {
    this.resetForm();
  }

  public team() {
    let _self = this;

    let url = _self.locator.config.get('endpoint.user') + '/team';

    this.locator.http.get(url, function (res: any, error: any) {
      if (error) {
        return;
      }
      _self.form.searchError = !res.success;
      _self.form.searchMessage = res.result['message'];

      if (res.success) {
        _self.form.list = res.result.data;
      }

      //Check empty list
      if (_self.form.list.length == 0) {
        _self.form.message = 'No record found';
        _self.form.error = true;
      }
    });
  }
}
